import {Component, Input, OnInit} from '@angular/core';
import {ExgModalService} from 'exc-controls-v2';
import {EnumerationService} from '../../../services/enumeration.service';
import {ApplicationService} from '../../../services/application.service';
import {ExcTranslation} from 'exc-core-v2';

@Component({
  selector: 'app-modal-region-route-editor',
  templateUrl: './modal-region-route-editor.component.html',
  styles: [],
})
export class ModalRegionRouteEditorComponent
  extends ExcTranslation
  implements OnInit
{
  @Input() data: any;
  hintText = {
    dFromdTo:
      'Datum "Bis" muss weiter in der Zukunft liegen, wie das "Von" Datum',
    tourInValid: 'Datum liegt außerhalb des geplanten Zeitraums',
  };

  dataInit = true;
  dataModel: {
    index: number | undefined;
    from: string | Date | undefined;
    to: string | Date | undefined;
    locations: [
      {
        postCode: string;
        from: string | Date | undefined;
        to: string | Date | undefined;
        capacity: number | undefined;
      }
    ];
  } = {
    index: undefined,
    from: undefined,
    to: undefined,
    locations: [
      {
        postCode: 'XXXXX',
        from: undefined,
        to: undefined,
        capacity: undefined,
      },
    ],
  };
  newLocation: {
    postCode: string;
    from: string | Date | undefined;
    to: string | Date | undefined;
    capacity: number | undefined;
  } = {
    postCode: 'XXXXX',
    from: undefined,
    to: undefined,
    capacity: undefined,
  };
  dataModelClone: any;

  constructor(
    public popUpService: ExgModalService,
    public enumSvc: EnumerationService,
    public appSvc: ApplicationService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.data) {
      delete this.data.until;
      this.dataModel = this.appSvc.helperObj.clone(this.data);
      this.dataModel.from = new Date(this.dataModel.from as string);
      this.dataModel.to = new Date(this.dataModel.to as string);
      // this.dataModel.locations.forEach((location) => {
      //   location.from = new Date(this.dataModel.from as string);
      //   location.to = new Date(this.dataModel.to as string);
      // });
      this.dataInit = false;
    }
    this.dataModelClone = this.appSvc.helperObj.clone(this.dataModel);
  }

  cancel(): void {
    this.close();
  }

  close(): void {
    this.popUpService.close();
  }

  save(): void {
    if (
      this.appSvc.helperObj.changed(this.dataModel, this.dataModelClone) ||
      !this.dateValid(this.dataModelClone.from, this.dataModelClone.to)
    ) {
      this.dataModelClone.from = new Date(this.dataModelClone.from).toJSON();
      this.dataModelClone.to = new Date(this.dataModelClone.to).toJSON();
      this.dataModel.locations.forEach((location) => {
        location.from = new Date(this.dataModel.from as string).toJSON();
        location.to = new Date(this.dataModel.to as string).toJSON();
      });
      this.popUpService.action(this.dataModelClone);
    }
  }

  addLocationObject(): void {
    this.dataModelClone.locations.push(
      this.appSvc.helperObj.clone(this.newLocation)
    );
  }

  changePostCode(location: any, $event: any): void {
    location.postCode = $event.trim();
  }

  focusOutPostCode(location: any): void {
    for (let i = 0; location.postCode.length < 5; i++) {
      location.postCode += 'X';
    }
  }

  removeRouteItem(location: any): void {
    if (this.dataModelClone.locations.length > 1) {
      this.dataModelClone.locations = this.dataModelClone.locations.filter(
        (loc: any) => loc !== location
      );
    }
  }

  dateValid(fromDate?: Date, toDate?: Date, dTour?: Date): boolean {
    if (fromDate && toDate) {
      if (dTour) {
        // ToDo: Bedinung korregieren
        // return false;
        return false;
      }
      if (fromDate > toDate) {
        return fromDate > toDate;
      }
    }
    return false;
  }
}
